import {
    Box,
    Card,
    CardContent,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { useTheme } from '@mui/system';

export default function BillingSummarySkeleton() {
    const theme = useTheme();
    return (
        <Card
            sx={{
                borderRadius: 2,
                border: `1px solid ${theme.palette.neutral.N_200}`,
                boxShadow: 'none',
            }}
        >
            <CardContent>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Box>
                        <Skeleton variant="text" width={180} height={28} />
                        <Skeleton variant="text" width={240} height={18} />
                    </Box>

                    <Skeleton variant="rounded" width={140} height={36} />
                </Box>

                {/* Table */}
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Skeleton variant="text" width={120} />
                            </TableCell>
                            <TableCell align="right">
                                <Skeleton variant="text" width={60} />
                            </TableCell>
                            <TableCell align="right">
                                <Skeleton variant="text" width={60} />
                            </TableCell>
                            <TableCell align="right">
                                <Skeleton variant="text" width={60} />
                            </TableCell>
                            <TableCell align="right">
                                <Skeleton variant="text" width={60} />
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {Array.from({ length: 2 }, (_, i) => (
                            <TableRow key={i}>
                                <TableCell>
                                    <Skeleton variant="text" width="60%" />
                                </TableCell>
                                <TableCell align="right">
                                    <Skeleton variant="text" width={60} />
                                </TableCell>
                                <TableCell align="right">
                                    <Skeleton variant="text" width={60} />
                                </TableCell>
                                <TableCell align="right">
                                    <Skeleton variant="text" width={60} />
                                </TableCell>
                                <TableCell align="right">
                                    <Skeleton variant="text" width={60} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* Totals */}
                <Stack spacing={1.5} alignItems="flex-end" mt={4}>
                    <Skeleton variant="text" width={160} height={28} />
                </Stack>
            </CardContent>
        </Card>
    );
}
